import "./view_course.css";
import Layout from "../../../layout/index";
import Input from "antd/lib/input";
import Select from "antd/lib/select";
import TextArea from "antd/lib/input/TextArea";
import Button from "antd/lib/button";
import { HiPlus } from "react-icons/hi";
import { BiEditAlt } from "react-icons/bi";
import { FaRegTrashAlt } from "react-icons/fa";
import Checkbox from "antd/lib/checkbox";
import { Fragment, useEffect, useRef, useState } from "react";
import Switch from "antd/lib/switch";
import CloadAdd from "../../../assets/icons/cloudAdd";
import Collapse from "antd/lib/collapse";
import { CiImageOn } from "react-icons/ci";
import Modal from "antd/lib/modal";
import { IoClose } from "react-icons/io5";
import { LuUpload } from "react-icons/lu";
import { IoCloseCircleOutline } from "react-icons/io5";
import { HiOutlineTrash } from "react-icons/hi";
import { MdAdd } from "react-icons/md";
import useCourses from "../../../hooks/use_courses";
import { formatSize } from "../../../helpers/format_size";
import { useLocation } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";
import { FiTrash } from "react-icons/fi";
import { formatUnit } from "../../../helpers/format_unit";
import Skeleton from "../../../components/skeleton";
import showFile from "../../../helpers/show_file";
import Tooltip from "antd/lib/tooltip";
import { FiEdit3 } from "react-icons/fi";
import Tabs from "antd/lib/tabs";
import Rate from "antd/lib/rate";
import LoadingPrimary from "../../../assets/animations/loading_primary.svg";
import Table from "antd/lib/table";
import Pagination from "antd/lib/pagination";
import { useSelector } from "react-redux";
import Empty from "antd/lib/empty";
import { IoMdMenu } from "react-icons/io";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { dateHelper } from "../../../helpers/date_helper";
import {
  AiFillDislike,
  AiFillLike,
  AiOutlineDislike,
  AiOutlineLike,
} from "react-icons/ai";
import Dropdown from "antd/lib/dropdown";
import { FaCirclePlay } from "react-icons/fa6";
import toast from "react-hot-toast";

const { Panel } = Collapse;

const ViewCourse = () => {
  const location = useLocation();
  const {
    // entity methods
    apiFileToHtmlFile,
    getCourseById,
    deleteSection,
    deleteLesson,
    deleteQuiz,
    deleteProduct,
    getReviews,
    getCourseMembers,
    reorderSections,
    reorderLessons,
    handleLikeReview,
    getCollections,
    getCollectionVideos,
    uploadContextFile,
    // controller methods
    createSectionController,
    updateSectionController,
    createLessonController,
    updateLessonController,
    createQuizController,
    updateQuizController,
    createProductController,
    updateProductController,
    replyReviewController,
    reportReviewController,
    generateCertificateController,
    // entity states
    viewCourseData,
    reviewsData,
    membersData,
    collectionsData,
    setCollectionsData,
    // controller states
    uploadLessonProgress,
    setUploadLessonProgress,
    reviewPaginates,
    membersPaginates,
    // modal states
    createSectionModal,
    setCreateSectionModal,
    updateSectionModal,
    setUpdateSectionModal,
    deleteSectionModal,
    setDeleteSectionModal,
    createLessonModal,
    setCreateLessonModal,
    updateLessonModal,
    setUpdateLessonModal,
    deleteLessonModal,
    setDeleteLessonModal,
    createQuizModal,
    setCreateQuizModal,
    updateQuizModal,
    setUpdateQuizModal,
    deleteQuizModal,
    setDeleteQuizModal,
    createProductModal,
    setCreateProductModal,
    updateProductModal,
    setUpdateProductModal,
    deleteProductModal,
    setDeleteProductModal,
    replyModal,
    setReplyModal,
    reportModal,
    setReportModal,
    certificateModal,
    setCertificateModal,
    // loading states
    loadings,
    getCollectionsLoading,
    uploadContextFileLoading,
  } = useCourses();

  const [activeTab, setActiveTab] = useState("1");
  const [activeKeys, setActiveKeys] = useState([]);
  const [collectionsActiveKeys, setCollectionsActiveKeys] = useState([]);

  const [selectedSection, setSelectedSection] = useState(null);
  const [selectedLesson, setSelectedLesson] = useState(null);
  const [selectedQuiz, setSelectedQuiz] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [libraryModal, setLibraryModal] = useState(false);
  const [libraryModalUpdate, setLibraryModalUpdate] = useState(false);

  const uploadLessonVideoRefCreate = useRef(null);
  const uploadLessonFilesRefCreate = useRef(null);
  const uploadLessonVideoRefUpdate = useRef(null);
  const uploadLessonFilesRefUpdate = useRef(null);
  const uploadProductImageRefCreate = useRef(null);
  const uploadProductImageRefUpdate = useRef(null);
  const generateCertificateRef = useRef(null);
  const createContextEditorRef = useRef(null);
  const updateContextEditorRef = useRef(null);

  const userProfile = useSelector((state) => state.app.userProfile);

  const columns = [
    {
      title: "Member",
      dataIndex: "user.fullname",
      key: "user",
      render: (_, record) => (
        <div>
          <div style={{ fontWeight: 500 }}>{record.user?.fullname}</div>
          <div style={{ color: "var(--black_50)", fontSize: 12 }}>
            {record.user?.email}
          </div>
        </div>
      ),
    },
    {
      title: "Member since",
      dataIndex: "createTime",
      key: "createTime",
      render: (text, record) => dateHelper(record.createTime),
    },
    {
      title: "Overall progress",
      width: 300,
      dataIndex: "progress",
      key: "progress",
      render: (progress, record) => (
        <div className="progress_bar_table">
          <div className="bar_table">
            <div style={{ width: `${progress > 100 ? 100 : progress}%` }}></div>
          </div>
          <span style={{ color: "#595959" }}>
            {progress > 100 ? 100 : progress}%
          </span>
        </div>
      ),
    },
    {
      title: "",
      width: 200,
      dataIndex: "id",
      key: "certificate",
      render: (progress, record) => (
        <div className="certificate_table">
          {record?.certificate ? (
            <div
              onClick={() => {
                window.open(showFile(record?.certificate), "_blank");
              }}
            >
              View Certificate
            </div>
          ) : null}
        </div>
      ),
    },
  ];

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const { source, destination, type } = result;

    // reorder sections
    if (type === "SECTION") {
      const reordered = Array.from(viewCourseData.course.sections);
      const [moved] = reordered.splice(source.index, 1);
      reordered.splice(destination.index, 0, moved);
      viewCourseData.course.sections = reordered;
      setActiveKeys([...activeKeys]);
      console.log(reordered);
      reorderSections(
        reordered.map((item) => {
          return item.id;
        }),
      );
      return;
    }

    // reorder lessons within the same section
    if (type.startsWith("LESSON-")) {
      const sectionId = type.split("-")[1];
      const section = viewCourseData.course.sections.find(
        (s) => String(s.id) === sectionId,
      );
      if (!section) return;

      const reordered = Array.from(section.lessons);
      const [movedLesson] = reordered.splice(source.index, 1);
      reordered.splice(destination.index, 0, movedLesson);
      section.lessons = reordered;
      reorderLessons(
        reordered.map((item) => {
          return item.id;
        }),
      );
      setActiveKeys([...activeKeys]);
    }
  };

  const items = [
    {
      key: "1",
      label: "Manage course",
      children: (
        <div className="new_course">
          {viewCourseData?.course?.status == 2 ? (
            <div className="pending_course_alert">
              The status of this course is pending and is not displayed to users
              on the platform. You can update your course informations and enter
              your sections and lessons, and after Naranel approves, the course
              will be displayed to users.
            </div>
          ) : null}
          <div className="upload_course_content">
            <div className="upload_course_content_title">
              <h3>Upload Your Course Content</h3>
              <p>
                You can upload your course sections along with their related
                lessons. Each lesson can include multiple files, such as videos,
                documents, and images, to provide a richer learning experience.
              </p>
            </div>
            <div className="collapse_container" id="course_collapse_container">
              {loadings.getCourseById ? (
                Array(3)
                  .fill()
                  .map((item, index) => (
                    <Skeleton
                      key={index}
                      style={{
                        width: "100%",
                        height: 56,
                        borderRadius: 8,
                        marginBottom: 16,
                      }}
                    />
                  ))
              ) : viewCourseData?.course?.sections?.length > 0 ? (
                <DragDropContext onDragEnd={handleDragEnd}>
                  <Droppable droppableId="sections" type="SECTION">
                    {(provided) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        {viewCourseData?.course?.sections?.map(
                          (section, index) => (
                            <Draggable
                              key={section.id}
                              draggableId={`section-${section.id}`}
                              index={index}
                            >
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  style={provided.draggableProps.style}
                                >
                                  <Collapse
                                    key={index}
                                    className={
                                      section.lessons?.length > 0
                                        ? "panel"
                                        : "locked_panel"
                                    }
                                    activeKey={activeKeys}
                                    onChange={(key) => setActiveKeys(key)}
                                    bordered={false}
                                    expandIconPosition="end"
                                    expandIcon={null}
                                  >
                                    <Panel
                                      header={
                                        <div
                                          className="label_collapse"
                                          {...provided.dragHandleProps}
                                        >
                                          <div>
                                            <div>
                                              <IoMdMenu />
                                            </div>
                                            <h4>{section.title}</h4>
                                          </div>
                                          <div>
                                            {!activeKeys.find(
                                              (o) => o == section.id,
                                            ) ? (
                                              <Button
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setCreateLessonModal(true);
                                                  createLessonController.setFieldValue(
                                                    "section_id",
                                                    section?.id,
                                                  );
                                                }}
                                                className="add_session_btn"
                                              >
                                                Add Lesson
                                              </Button>
                                            ) : (
                                              <Fragment>
                                                <Button
                                                  className="edit_btn_collapse"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    setUpdateSectionModal(true);
                                                    updateSectionController.setFieldValue(
                                                      "id",
                                                      section.id,
                                                    );
                                                    updateSectionController.setFieldValue(
                                                      "title",
                                                      section.title,
                                                    );
                                                    updateSectionController.setFieldValue(
                                                      "description",
                                                      section.description,
                                                    );
                                                  }}
                                                >
                                                  <BiEditAlt />
                                                </Button>
                                                <Button
                                                  className="trash_btn_collapse"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    setDeleteSectionModal(true);
                                                    setSelectedSection(section);
                                                  }}
                                                >
                                                  <FaRegTrashAlt />
                                                </Button>
                                              </Fragment>
                                            )}
                                          </div>
                                        </div>
                                      }
                                      key={section.id}
                                      className="custom_panel"
                                      showArrow={false}
                                    >
                                      <Droppable
                                        droppableId={`lessons-${section.id}`}
                                        type={`LESSON-${section.id}`}
                                      >
                                        {(lessonProvided) => (
                                          <div
                                            ref={lessonProvided.innerRef}
                                            {...lessonProvided.droppableProps}
                                          >
                                            {section.lessons?.map(
                                              (lesson, lessonIndex) => (
                                                <Draggable
                                                  key={lesson.id}
                                                  draggableId={`lesson-${lesson.id}`}
                                                  index={lessonIndex}
                                                >
                                                  {(lessonDraggable) => (
                                                    <div
                                                      ref={
                                                        lessonDraggable.innerRef
                                                      }
                                                      {...lessonDraggable.draggableProps}
                                                      {...lessonDraggable.dragHandleProps}
                                                      className="content_collapse_items"
                                                      style={
                                                        lessonDraggable
                                                          .draggableProps.style
                                                      }
                                                    >
                                                      <div className="content_collapse_items_left">
                                                        <div>
                                                          <div>
                                                            <IoMdMenu />
                                                          </div>
                                                          <div>
                                                            <Tooltip
                                                              title={
                                                                lesson?.title
                                                                  ?.length > 20
                                                                  ? lesson?.title
                                                                  : null
                                                              }
                                                              trigger={"hover"}
                                                            >
                                                              <h3>
                                                                {lesson?.title
                                                                  ?.length > 20
                                                                  ? lesson?.title?.slice(
                                                                      0,
                                                                      20,
                                                                    ) + "..."
                                                                  : lesson?.title}
                                                              </h3>
                                                            </Tooltip>
                                                            <Tooltip
                                                              title={
                                                                lesson
                                                                  ?.description
                                                                  ?.length > 20
                                                                  ? lesson?.description
                                                                  : null
                                                              }
                                                              trigger={"hover"}
                                                            >
                                                              <p>
                                                                {lesson
                                                                  ?.description
                                                                  ?.length > 20
                                                                  ? lesson?.description?.slice(
                                                                      0,
                                                                      20,
                                                                    ) + "..."
                                                                  : lesson.description}
                                                              </p>
                                                            </Tooltip>
                                                          </div>
                                                        </div>
                                                        {lesson?.file ? (
                                                          <div
                                                            style={{
                                                              flexDirection:
                                                                "column",
                                                              alignItems:
                                                                "flex-start",
                                                            }}
                                                          >
                                                            <Tooltip
                                                              title={
                                                                lesson?.file
                                                                  ?.originalName
                                                                  ?.length > 20
                                                                  ? lesson?.file
                                                                      ?.originalName
                                                                  : null
                                                              }
                                                              trigger={"hover"}
                                                            >
                                                              <h3
                                                                style={{
                                                                  fontSize: 15,
                                                                }}
                                                              >
                                                                {lesson?.file
                                                                  ?.originalName
                                                                  ?.length > 20
                                                                  ? lesson?.file?.originalName?.slice(
                                                                      0,
                                                                      20,
                                                                    ) + "..."
                                                                  : lesson?.file
                                                                      ?.originalName}
                                                              </h3>
                                                            </Tooltip>
                                                            <p>
                                                              {formatUnit(
                                                                lesson?.duration,
                                                              )}{" "}
                                                              (
                                                              {formatSize(
                                                                lesson?.file
                                                                  ?.size,
                                                              )}
                                                              )
                                                            </p>
                                                          </div>
                                                        ) : (
                                                          <div>
                                                            No video yet!
                                                          </div>
                                                        )}
                                                      </div>
                                                      <div className="content_collapse_items_right">
                                                        <div>
                                                          <Button
                                                            loading={
                                                              lesson.loading
                                                            }
                                                            onClick={async () => {
                                                              lesson[
                                                                "loading"
                                                              ] = true;
                                                              updateLessonController.resetForm();

                                                              const values = {
                                                                id:
                                                                  lesson?.id ||
                                                                  null,
                                                                title:
                                                                  lesson?.title ||
                                                                  "",
                                                                description:
                                                                  lesson?.description ||
                                                                  "",
                                                                free:
                                                                  lesson?.free ||
                                                                  false,
                                                                context:
                                                                  lesson?.context ||
                                                                  "",
                                                                video: null,
                                                                attachment: [],
                                                              };

                                                              if (
                                                                lesson?.file
                                                              ) {
                                                                values.video = {
                                                                  file: lesson.file,
                                                                  url: showFile(
                                                                    lesson.file
                                                                      ?.name,
                                                                  ),
                                                                  id: lesson
                                                                    .file?.id,
                                                                };
                                                              }

                                                              if (
                                                                lesson
                                                                  ?.attachments
                                                                  ?.length > 0
                                                              ) {
                                                                try {
                                                                  values.attachment =
                                                                    await Promise.all(
                                                                      lesson.attachments.map(
                                                                        async (
                                                                          attach,
                                                                        ) =>
                                                                          apiFileToHtmlFile(
                                                                            attach.file,
                                                                          ),
                                                                      ),
                                                                    );
                                                                } catch (e) {
                                                                  console.error(
                                                                    "Attachment load failed",
                                                                    e,
                                                                  );
                                                                }
                                                              }

                                                              updateLessonController.setValues(
                                                                values,
                                                              );
                                                              lesson[
                                                                "loading"
                                                              ] = false;
                                                              setUpdateLessonModal(
                                                                true,
                                                              );
                                                            }}
                                                          >
                                                            <BiEditAlt />
                                                          </Button>
                                                          <Button
                                                            onClick={() => {
                                                              setDeleteLessonModal(
                                                                true,
                                                              );
                                                              setSelectedLesson(
                                                                lesson,
                                                              );
                                                            }}
                                                          >
                                                            <FaRegTrashAlt />
                                                          </Button>
                                                        </div>
                                                        <div>
                                                          {lesson?.products
                                                            ?.length > 0 ? (
                                                            <div>
                                                              {
                                                                lesson?.products
                                                                  ?.length
                                                              }{" "}
                                                              Products
                                                            </div>
                                                          ) : null}
                                                          {lesson?.attachments
                                                            ?.length > 0 ? (
                                                            <div>
                                                              {
                                                                lesson
                                                                  ?.attachments
                                                                  ?.length
                                                              }{" "}
                                                              Files
                                                            </div>
                                                          ) : null}
                                                          {lesson?.context
                                                            ?.length > 0 ? (
                                                            <div>
                                                              Include Context
                                                            </div>
                                                          ) : null}
                                                        </div>
                                                      </div>
                                                      {lesson.free ? (
                                                        <div className="lesson_free_label">
                                                          <div>FREE</div>
                                                        </div>
                                                      ) : null}
                                                      <div className="view_course_lesson_card_mobile">
                                                        <div>
                                                          {lesson?.products
                                                            ?.length > 0 ? (
                                                            <div>
                                                              {
                                                                lesson?.products
                                                                  ?.length
                                                              }{" "}
                                                              Products
                                                            </div>
                                                          ) : null}
                                                          {lesson?.attachments
                                                            ?.length > 0 ? (
                                                            <div>
                                                              {
                                                                lesson
                                                                  ?.attachments
                                                                  ?.length
                                                              }{" "}
                                                              Files
                                                            </div>
                                                          ) : null}
                                                          {lesson?.context
                                                            ?.length > 0 ? (
                                                            <div>
                                                              Include Context
                                                            </div>
                                                          ) : null}
                                                        </div>
                                                        {lesson.free ? (
                                                          <div>
                                                            <div>FREE</div>
                                                          </div>
                                                        ) : null}
                                                      </div>
                                                    </div>
                                                  )}
                                                </Draggable>
                                              ),
                                            )}
                                            {lessonProvided.placeholder}
                                          </div>
                                        )}
                                      </Droppable>

                                      {section.quizzes?.map(
                                        (quiz, quizIndex) => (
                                          <div
                                            key={quizIndex}
                                            className="content_collapse_items"
                                          >
                                            <div className="content_collapse_items_left">
                                              <div>
                                                <div
                                                  style={{
                                                    background: "var(--blue)",
                                                    color: "white",
                                                  }}
                                                >
                                                  <FiEdit3 />
                                                </div>
                                                <div>
                                                  <Tooltip
                                                    title={
                                                      quiz?.title?.length > 30
                                                        ? quiz?.title
                                                        : null
                                                    }
                                                    trigger={"hover"}
                                                  >
                                                    <h3>
                                                      {quiz?.title?.length > 30
                                                        ? quiz?.title?.slice(
                                                            0,
                                                            30,
                                                          ) + "..."
                                                        : quiz?.title}
                                                    </h3>
                                                  </Tooltip>
                                                </div>
                                              </div>
                                              <div
                                                style={{
                                                  flexDirection: "column",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <h3 style={{ fontSize: 15 }}>
                                                  {quiz?.questions?.length}{" "}
                                                  Questions
                                                </h3>
                                              </div>
                                            </div>
                                            <div className="content_collapse_items_right">
                                              <div>
                                                <Button
                                                  onClick={async () => {
                                                    let questionsArray = [];
                                                    setUpdateQuizModal(true);
                                                    updateQuizController.setFieldValue(
                                                      "quiz_id",
                                                      quiz.id,
                                                    );
                                                    updateQuizController.setFieldValue(
                                                      "quiz_title",
                                                      quiz.title,
                                                    );
                                                    quiz.questions?.map(
                                                      (ques) => {
                                                        questionsArray.push({
                                                          id: ques.id,
                                                          title: ques.title,
                                                          answers:
                                                            ques.options?.map(
                                                              (opt) => {
                                                                return {
                                                                  id: opt.id,
                                                                  title:
                                                                    opt.title,
                                                                  isAnswer:
                                                                    opt.isAnswer,
                                                                };
                                                              },
                                                            ),
                                                        });
                                                      },
                                                    );
                                                    updateQuizController.setFieldValue(
                                                      "questions",
                                                      questionsArray,
                                                    );
                                                  }}
                                                >
                                                  <BiEditAlt />
                                                </Button>
                                                <Button
                                                  onClick={() => {
                                                    setDeleteQuizModal(true);
                                                    setSelectedQuiz(quiz);
                                                  }}
                                                >
                                                  <FaRegTrashAlt />
                                                </Button>
                                              </div>
                                            </div>
                                          </div>
                                        ),
                                      )}

                                      <Button
                                        onClick={() => {
                                          setCreateLessonModal(true);
                                          createLessonController.setFieldValue(
                                            "section_id",
                                            section?.id,
                                          );
                                        }}
                                        className="new_session_btn"
                                      >
                                        <HiPlus /> New Lesson
                                      </Button>
                                      <Button
                                        className="add_quiz_btn"
                                        onClick={() => {
                                          setCreateQuizModal(true);
                                          createQuizController.setFieldValue(
                                            "section_id",
                                            section.id,
                                          );
                                        }}
                                      >
                                        <HiPlus />
                                        New Quiz
                                      </Button>
                                    </Panel>
                                  </Collapse>
                                </div>
                              )}
                            </Draggable>
                          ),
                        )}
                        {/* {provided.placeholder} */}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              ) : null}
            </div>
            <Button
              onClick={() => {
                setCreateSectionModal(true);
              }}
              className="new_lesson_btn"
              disabled={loadings.getCourseById}
            >
              <HiPlus /> New Section
            </Button>
          </div>
          <div className="mentioned_products">
            <div className="mentioned_products_title">
              <h3>Mentioned Products</h3>
              <p>
                If you refer to any products, tools, or services in your course,
                you can list them here with a title, short description, and
                external link.
              </p>
            </div>
            {loadings.getCourseById
              ? Array(2)
                  .fill()
                  .map((item, index) => (
                    <Skeleton
                      key={index}
                      style={{
                        width: "100%",
                        height: 62,
                        borderRadius: 12,
                        marginBottom: 16,
                      }}
                    />
                  ))
              : viewCourseData?.products?.map((product, index) => (
                  <div
                    key={index}
                    className="content_collapse_items content_collapse_items_product"
                  >
                    <div className="content_collapse_items_left content_collapse_items_left_product">
                      <div>
                        <div>{index + 1}</div>
                        {product?.file ? (
                          <img
                            style={{
                              width: 36,
                              height: 36,
                              objectFit: "cover",
                              marginRight: 8,
                            }}
                            src={showFile(product?.file?.name)}
                          />
                        ) : (
                          <CiImageOn
                            style={{
                              fontSize: 36,
                              marginRight: 8,
                              color: "var(--text)",
                            }}
                          />
                        )}
                        <div>
                          <h3>{product?.title}</h3>
                          <Tooltip
                            title={
                              product?.description?.length > 30
                                ? product?.description
                                : null
                            }
                            trigger={"hover"}
                          >
                            <p>
                              {product?.description?.length > 30
                                ? product?.description?.slice(0, 30) + "..."
                                : product?.description}
                            </p>
                          </Tooltip>
                        </div>
                      </div>
                      <div>
                        <div>Use in {product?.lessons?.length} lessons</div>
                      </div>
                    </div>
                    <div className="url_collapse">
                      <Tooltip
                        title={
                          product?.link?.length > 20 ? product?.link : null
                        }
                        trigger={"hover"}
                      >
                        <p>
                          {product?.link?.length > 20
                            ? product?.link?.slice(0, 20) + "..."
                            : product?.link}
                        </p>
                      </Tooltip>
                    </div>
                    <div className="content_collapse_items_right">
                      <div>
                        <Button
                          className="edit_btn_collapse"
                          onClick={async () => {
                            let array = [];
                            setUpdateProductModal(true);
                            updateProductController.setFieldValue(
                              "id",
                              product?.id,
                            );
                            updateProductController.setFieldValue(
                              "title",
                              product.title,
                            );
                            updateProductController.setFieldValue(
                              "description",
                              product.description,
                            );
                            updateProductController.setFieldValue(
                              "link",
                              product.link,
                            );
                            product?.lessons?.map((lesson) => {
                              array.push(lesson.id);
                            });
                            updateProductController.setFieldValue(
                              "lessonIds",
                              array,
                            );
                            if (product?.file) {
                              updateProductController.setFieldValue("product", {
                                file: product?.file,
                                id: product?.file?.id,
                                url: showFile(product?.file?.name),
                              });
                            }
                          }}
                        >
                          <BiEditAlt />
                        </Button>
                        <Button
                          className="trash_btn_collapse"
                          onClick={() => {
                            setSelectedProduct(product);
                            setDeleteProductModal(true);
                          }}
                        >
                          <FaRegTrashAlt />
                        </Button>
                      </div>
                    </div>
                  </div>
                ))}
            <Button
              className="new_product_btn"
              onClick={() => {
                setCreateProductModal(true);
              }}
              disabled={loadings.getCourseById}
            >
              <HiPlus />
              New Product
            </Button>
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: "Reviews",
      children: (
        <div className="new_course">
          {viewCourseData?.course?.status == 2 ? (
            <div className="pending_course_alert">
              The status of this course is pending and is not displayed to users
              on the platform. You can update your course informations and enter
              your sections and lessons, and after Naranel approves, the course
              will be displayed to users.
            </div>
          ) : null}
          {/* reviews loading */}
          {loadings.getReviews
            ? Array(4)
                .fill()
                .map((item, index) => (
                  <Skeleton
                    key={index}
                    style={{
                      width: "100%",
                      borderRadius: 8,
                      marginBottom: 12,
                      height: 125,
                    }}
                  />
                ))
            : null}
          {/* reviews */}
          {!loadings.getReviews && reviewsData?.length > 0 ? (
            <div className={"comments_users"}>
              {reviewsData?.map((review, index) => (
                <div
                  onClick={() => {
                    console.log(review);
                  }}
                  key={index}
                  className={"comments_item"}
                >
                  <div>
                    <div>
                      <div>
                        <div>
                          {review?.user?.avatar ? (
                            <img
                              src={showFile(review?.user?.avatar)}
                              alt={review?.user?.fullname}
                            />
                          ) : (
                            <div>
                              {review?.user?.fullname
                                ?.slice(0, 1)
                                ?.toUpperCase()}
                            </div>
                          )}
                        </div>
                        <div>{review?.user?.fullname}</div>
                        <span style={{ fontSize: 12 }}>
                          {dateHelper(review?.createTime)}
                        </span>
                      </div>
                      <div
                        style={{
                          whiteSpace: "pre-line",
                        }}
                      >
                        {review?.comment}
                      </div>
                      <div className="comments_item_like_actions">
                        <Button
                          onClick={() => {
                            if (!loadings.handleLikeReview) {
                              handleLikeReview(review, "like");
                            }
                          }}
                          id={
                            review?.isLiked == true ? "like_btn_active" : null
                          }
                        >
                          {review?.isLiked == true ? (
                            <AiFillLike style={{ fontSize: 20 }} />
                          ) : (
                            <AiOutlineLike style={{ fontSize: 20 }} />
                          )}
                          <span>
                            {review?.likeCount ? review?.likeCount : 0}
                          </span>
                        </Button>
                        <Button
                          onClick={() => {
                            if (!loadings.handleLikeReview) {
                              handleLikeReview(review, "dislike");
                            }
                          }}
                          id={
                            review?.isLiked == false ? "like_btn_active" : null
                          }
                        >
                          {review?.isLiked == false ? (
                            <AiFillDislike style={{ fontSize: 20 }} />
                          ) : (
                            <AiOutlineDislike style={{ fontSize: 20 }} />
                          )}
                          <span>
                            {review?.dislikeCount ? review?.dislikeCount : 0}
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className={"comments_item_right"}>
                      <Rate
                        disabled
                        defaultValue={review?.rating?.toFixed(1)}
                      />
                      <span>({review.rating?.toFixed(1)}/5)</span>
                    </div>
                  </div>
                  {review?.replies?.length > 0 ? (
                    <div className={"comment_replies"}>
                      {review?.replies?.map((reply, replyIndex) => (
                        <div key={replyIndex}>
                          <div>
                            <div>
                              {reply?.user?.avatar ? (
                                <img
                                  src={showFile(reply?.user?.avatar)}
                                  alt={reply?.user?.name}
                                />
                              ) : (
                                <div>
                                  {reply?.user?.name
                                    ?.slice(0, 1)
                                    ?.toUpperCase()}
                                </div>
                              )}
                            </div>
                            <div>{reply?.user?.name}</div>
                            <span>{dateHelper(reply?.createTime)}</span>
                          </div>
                          <div>{reply?.comment}</div>
                        </div>
                      ))}
                    </div>
                  ) : null}
                  <div
                    style={{
                      right: 16,
                      left: "unset",
                      bottom: 20,
                      height: "unset",
                      top: "unset",
                    }}
                  >
                    <div
                      onClick={() => {
                        if (!review.report) {
                          setReportModal(true);
                          reportReviewController.setFieldValue(
                            "reviewId",
                            review?.id,
                          );
                        }
                      }}
                      style={
                        review.report
                          ? { cursor: "unset", fontSize: 12 }
                          : { cursor: "pointer" }
                      }
                    >
                      {review.report
                        ? `Reported at ${dateHelper(review.report?.createTime)}`
                        : "Report"}
                    </div>
                    {review.replies?.length == 0 ? (
                      <div
                        onClick={() => {
                          setReplyModal(true);
                          replyReviewController.setFieldValue(
                            "reviewId",
                            review?.id,
                          );
                        }}
                      >
                        Reply
                      </div>
                    ) : null}
                  </div>
                </div>
              ))}
            </div>
          ) : null}
          {/* empty */}
          {!loadings.getReviews && reviewsData.length == 0 ? (
            <Empty
              description="No reviews founded"
              style={{
                width: "100%",
                padding: "48px 0",
              }}
            />
          ) : null}
          {/* reviews paginates */}
          {reviewPaginates.has_more ? (
            <div className={"view_course_load_more_comments"}>
              {loadings.getReviewsPaginate ? (
                <img
                  src={LoadingPrimary}
                  width={20}
                  height={20}
                  alt="Loading..."
                />
              ) : (
                <div
                  onClick={() => {
                    getReviews(reviewPaginates.current + 1);
                  }}
                >
                  Load more reviews
                </div>
              )}
            </div>
          ) : null}
        </div>
      ),
    },
    {
      key: "3",
      label: "Members",
      children: (
        <div className="new_course">
          {viewCourseData?.course?.status == 2 ? (
            <div className="pending_course_alert">
              The status of this course is pending and is not displayed to users
              on the platform. You can update your course informations and enter
              your sections and lessons, and after Naranel approves, the course
              will be displayed to users.
            </div>
          ) : null}
          {/* member_body */}
          <div className="upload_course_content">
            {/* table_container */}
            <div className="table_container">
              <Table
                loading={loadings.getCourseMembers}
                columns={columns}
                dataSource={membersData}
                pagination={false}
                bordered={false}
              />
            </div>
            {membersData.map((data, index) => (
              <div key={index} className="tabel_container_mobile">
                <div>
                  <p>Member name</p>
                  <span>{data?.user?.fullname}</span>
                </div>
                <div>
                  <p>Member since</p>
                  <span>{dateHelper(data.createTime)}</span>
                </div>
                <div>
                  <div className="bar_table_mobile">
                    <div
                      style={{
                        width: `${data?.progress > 100 ? 100 : data.progress}%`,
                      }}
                    ></div>
                  </div>
                  <span>{data?.progress > 100 ? 100 : data.progress}%</span>
                </div>
                {data?.certificate ? (
                  <Button
                    onClick={() => {
                      window.open(showFile(data?.certificate), "_blank");
                    }}
                  >
                    View Certificate
                  </Button>
                ) : null}
              </div>
            ))}
          </div>
          <Pagination
            style={{ marginTop: 24 }}
            current={membersPaginates.current}
            pageSize={10}
            onChange={(page) => {
              getCourseMembers(page);
            }}
            total={membersPaginates.total * 10}
          />
        </div>
      ),
    },
  ];

  const handleUploadNewLesson = (e) => {
    if (e.target.files[0]) {
      createLessonController.setFieldValue("video", {
        file: e.target.files[0],
        url: URL.createObjectURL(e.target.files[0]),
      });
    }
    e.target.value = null;
  };

  const handleUploadNewLessonFiles = (e) => {
    const files = e.currentTarget?.files;
    if (!files || files.length === 0) return;
    const prev = Array.isArray(createLessonController.values.attachment)
      ? createLessonController.values.attachment
      : [];
    const newFiles = Array.from(files);
    const key = (f) => `${f.name}-${f.size}-${f.lastModified}`;
    const existingKeys = new Set(prev.map(key));
    const merged = [
      ...prev,
      ...newFiles.filter((f) => !existingKeys.has(key(f))),
    ];
    createLessonController.setFieldValue("attachment", merged);
    e.currentTarget.value = "";
  };

  const handleUploadNewLessonUpdate = (e) => {
    if (e.target.files[0]) {
      updateLessonController.setFieldValue("video", {
        file: e.target.files[0],
        url: URL.createObjectURL(e.target.files[0]),
      });
    }
    e.target.value = null;
  };

  const handleUploadNewLessonFilesUpdate = (e) => {
    const files = e.currentTarget?.files;
    if (!files || files.length === 0) return;
    const prev = Array.isArray(updateLessonController.values.attachment)
      ? updateLessonController.values.attachment
      : [];
    const newFiles = Array.from(files);
    const key = (f) => `${f.name}-${f.size}-${f.lastModified}`;
    const existingKeys = new Set(prev.map(key));
    const merged = [
      ...prev,
      ...newFiles.filter((f) => !existingKeys.has(key(f))),
    ];
    updateLessonController.setFieldValue("attachment", merged);
    e.currentTarget.value = "";
  };

  const handleUploadNewProduct = (e) => {
    if (e.target.files[0]) {
      createProductController.setFieldValue("product", {
        file: e.target.files[0],
        url: URL.createObjectURL(e.target.files[0]),
      });
    }
    e.target.value = null;
  };

  const handleUploadUpdateProduct = (e) => {
    if (e.target.files[0]) {
      updateProductController.setFieldValue("product", {
        file: e.target.files[0],
        url: URL.createObjectURL(e.target.files[0]),
      });
    }
    e.target.value = null;
  };

  const handleUploadCertificate = (e) => {
    if (e.target.files[0]) {
      generateCertificateController.setFieldValue("certificate", {
        file: e.target.files[0],
        url: URL.createObjectURL(e.target.files[0]),
      });
    }
    e.target.value = null;
  };

  useEffect(() => {
    if (!createQuizModal) {
      createQuizController.resetForm();
    }
    if (!updateQuizModal) {
      updateQuizController.resetForm();
    }
  }, [createQuizModal, updateQuizModal]);

  useEffect(() => {
    if (!createLessonModal) {
      createLessonController.resetForm();
      setUploadLessonProgress(0);
    }
    if (!updateLessonModal) {
      updateLessonController.resetForm();
      setUploadLessonProgress(0);
    }
  }, [createLessonModal, updateLessonModal]);

  useEffect(() => {
    if (!createSectionModal) {
      createSectionController.resetForm();
    }
    if (!updateSectionModal) {
      updateSectionController.resetForm();
    }
  }, [createSectionModal, updateSectionModal]);

  useEffect(() => {
    if (!createProductModal) {
      createProductController.resetForm();
    }
    if (!updateProductModal) {
      updateProductController.resetForm();
    }
  }, [createProductModal, updateProductModal]);

  useEffect(() => {
    if (userProfile) {
      if (activeTab == "1") {
        getCourseById(location.pathname.split("/")[3]);
      }
      if (activeTab == "2") {
        getReviews(1);
      }
      if (activeTab == "3") {
        getCourseMembers(1);
      }
    }
  }, [activeTab, userProfile]);

  useEffect(() => {
    if (!replyModal) {
      replyReviewController.resetForm();
    }
  }, [replyModal]);

  useEffect(() => {
    if (!reportModal) {
      reportReviewController.resetForm();
    }
  }, [reportModal]);

  useEffect(() => {
    if (!certificateModal) {
      generateCertificateController.resetForm();
    }
  }, [certificateModal]);

  useEffect(() => {
    if (libraryModal) {
      getCollections();
    } else {
      setCollectionsData([]);
      setCollectionsActiveKeys([]);
    }
  }, [libraryModal]);

  useEffect(() => {
    if (libraryModalUpdate) {
      getCollections();
    } else {
      setCollectionsData([]);
      setCollectionsActiveKeys([]);
    }
  }, [libraryModalUpdate]);

  const showTinyMceDialogLoading = () => {
    const dialog = document.querySelector(".tox-dialog");

    if (!dialog) return;

    // avoid duplicate loading
    if (dialog.querySelector(".tiny-dialog-upload-loading")) return;

    const loading = document.createElement("div");
    loading.className = "tiny-dialog-upload-loading";
    loading.innerHTML = `
    <div class="tiny-dialog-upload-loading-box">
      <div class="tiny-dialog-upload-spinner"></div>
      <div>Uploading image...</div>
    </div>
  `;

    dialog.appendChild(loading);
  };

  const hideTinyMceDialogLoading = () => {
    const loading = document.querySelector(".tiny-dialog-upload-loading");
    if (loading) {
      loading.remove();
    }
  };

  const getContextEditorInit = (editorRef) => ({
    height: 500,
    menubar: true,
    plugins: [
      "advlist",
      "autolink",
      "lists",
      "link",
      "image",
      "charmap",
      "preview",
      "anchor",
      "searchreplace",
      "visualblocks",
      "code",
      "fullscreen",
      "insertdatetime",
      "table",
      "help",
      "wordcount",
    ],
    toolbar:
      "undo redo | blocks | bold italic underline | " +
      "alignleft aligncenter alignright alignjustify | " +
      "bullist numlist outdent indent | link image media table | code",

    paste_block_drop: true,
    paste_data_images: false,
    automatic_uploads: true,
    file_picker_types: "image",

    images_upload_handler: async (blobInfo) => {
      const editor = editorRef.current;

      try {
        editor?.setProgressState(true);

        const file = new File([blobInfo.blob()], blobInfo.filename(), {
          type: blobInfo.blob().type,
        });

        const uploaded = await uploadContextFile(file);

        return uploaded.url;
      } finally {
        editor?.setProgressState(false);
      }
    },

    file_picker_callback: (cb, value, meta) => {
      if (meta.filetype !== "image") return;

      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";

      input.onchange = async () => {
        const file = input.files?.[0];
        if (!file) return;

        const editor = editorRef.current;

        try {
          showTinyMceDialogLoading();
          editor?.setProgressState(true);

          const uploaded = await uploadContextFile(file);

          cb(uploaded.url, {
            title: uploaded.originalName || file.name,
            alt: uploaded.originalName || file.name,
          });
        } catch (error) {
          console.error("TinyMCE image upload failed:", error);
          toast.error("Image upload failed");
        } finally {
          hideTinyMceDialogLoading();
          editor?.setProgressState(false);
        }
      };

      input.click();
    },
  });

  return (
    <Layout>
      <Tabs
        className="course_preview_tabs"
        activeKey={activeTab}
        onChange={(key) => {
          setActiveTab(key);
        }}
        items={items}
      />
      {/* create section modal */}
      <Modal
        open={createSectionModal}
        onCancel={() => {
          setCreateSectionModal(false);
        }}
        footer={null}
        className="editLessonModal"
        closeIcon={null}
      >
        <form
          onSubmit={createSectionController.handleSubmit}
          className="edit_lesson_modal_container"
        >
          <div className="edit_lesson_modal_title">
            <Button
              onClick={() => {
                setCreateSectionModal(false);
              }}
            >
              <IoClose />
            </Button>
            <h3>New Section</h3>
          </div>
          {/* title */}
          <div>
            <label htmlFor="title">Title</label>
            <Input
              name="title"
              id="title"
              value={createSectionController.values.title}
              onChange={createSectionController.handleChange}
              disabled={loadings.createSection}
              status={
                createSectionController.touched.title &&
                createSectionController.errors.title
                  ? "error"
                  : ""
              }
            />
          </div>
          {/* description */}
          <div>
            <label>Description</label>
            <TextArea
              name="description"
              id="description"
              value={createSectionController.values.description}
              onChange={createSectionController.handleChange}
              disabled={loadings.createSection}
              rows={4}
              status={
                createSectionController.touched.description &&
                createSectionController.errors.description
                  ? "error"
                  : ""
              }
            />
          </div>
          <div className="edit_lesson_modal_btn">
            <Button htmlType="submit" loading={loadings.createSection}>
              Post
            </Button>
            <Button
              disabled={loadings.createSection}
              onClick={() => {
                setCreateSectionModal(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </form>
      </Modal>
      {/* update section modal */}
      <Modal
        open={updateSectionModal}
        onCancel={() => {
          setUpdateSectionModal(false);
        }}
        footer={null}
        className="editLessonModal"
        closeIcon={null}
      >
        <form
          onSubmit={updateSectionController.handleSubmit}
          className="edit_lesson_modal_container"
        >
          <div className="edit_lesson_modal_title">
            <Button
              onClick={() => {
                setUpdateSectionModal(false);
              }}
            >
              <IoClose />
            </Button>
            <h3>Edit Section</h3>
          </div>
          {/* title */}
          <div>
            <label htmlFor="title">Title</label>
            <Input
              name="title"
              id="title"
              value={updateSectionController.values.title}
              onChange={updateSectionController.handleChange}
              disabled={loadings.updateSection}
              status={
                updateSectionController.touched.title &&
                updateSectionController.errors.title
                  ? "error"
                  : ""
              }
            />
          </div>
          {/* description */}
          <div>
            <label>Description</label>
            <TextArea
              name="description"
              id="description"
              value={updateSectionController.values.description}
              onChange={updateSectionController.handleChange}
              disabled={loadings.updateSection}
              status={
                updateSectionController.touched.description &&
                updateSectionController.errors.description
                  ? "error"
                  : ""
              }
            />
          </div>
          <div className="edit_lesson_modal_btn">
            <Button htmlType="submit" loading={loadings.updateSection}>
              Save Changes
            </Button>
            <Button
              disabled={loadings.updateSection}
              onClick={() => {
                setUpdateSectionModal(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </form>
      </Modal>
      {/* delete section modal */}
      <Modal
        open={deleteSectionModal}
        onCancel={() => {
          setDeleteSectionModal(false);
        }}
        footer={null}
        className="deleteCourseModal"
        closeIcon={null}
      >
        <div className="delete_course_modal_container">
          <div className="delete_course_modal_title">
            <Button
              onClick={() => {
                setDeleteSectionModal(false);
              }}
            >
              <IoClose />
            </Button>
            <IoCloseCircleOutline />
          </div>
          <div>
            <h3>Are you sure you want to permanently delete this section?</h3>
            <p>
              All lessons, products and quizzes associated with this section
              will also be deleted.
            </p>
          </div>
          <div className="delete_course_modal_btn">
            <Button
              onClick={() => {
                setDeleteSectionModal(false);
              }}
              disabled={loadings.deleteSection}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                deleteSection(selectedSection?.id);
              }}
              loading={loadings.deleteSection}
            >
              Yes, Delete
            </Button>
          </div>
        </div>
      </Modal>
      {/* create lesson modal */}
      <Modal
        open={createLessonModal}
        onCancel={() => {
          setCreateLessonModal(false);
        }}
        footer={null}
        className="addSessionModal"
        closeIcon={null}
      >
        <form
          onSubmit={createLessonController.handleSubmit}
          className="add_session_modal"
        >
          <div className="add_session_modal_title">
            <Button
              onClick={() => {
                setCreateLessonModal(false);
              }}
            >
              <IoClose />
            </Button>
            <h3>New Lesson</h3>
          </div>
          <div className="add_session_modal_content">
            <div className="add_session_modal_content_left">
              {/* title */}
              <div>
                <div>Title</div>
                <Input
                  value={createLessonController.values.title}
                  onChange={createLessonController.handleChange}
                  name="title"
                  id="title"
                  disabled={loadings.createLesson}
                  status={
                    createLessonController.touched.title &&
                    createLessonController.errors.title
                      ? "error"
                      : ""
                  }
                />
              </div>
              {/* description */}
              <div>
                <div>Description</div>
                <Input
                  value={createLessonController.values.description}
                  onChange={createLessonController.handleChange}
                  name="description"
                  id="description"
                  disabled={loadings.createLesson}
                />
              </div>
              {/* free */}
              <div>
                <div>Free Lesson</div>
                <Switch
                  checked={createLessonController.values.free}
                  onChange={(value) => {
                    createLessonController.setFieldValue("free", value);
                  }}
                  disabled={loadings.createLesson}
                />
              </div>
              {/* files */}
              <div>
                <div>
                  <div>Add files</div>
                  <Button
                    onClick={() => {
                      uploadLessonFilesRefCreate.current.click();
                    }}
                    disabled={loadings.createLesson}
                    icon={<LuUpload />}
                  >
                    Click to Upload
                  </Button>
                </div>
                {createLessonController.values.attachment?.map(
                  (file, index) => (
                    <div className="create_lesson_file_card" key={index}>
                      <div>
                        <div>{file?.name}</div>
                        <div>{formatSize(file?.size)}</div>
                      </div>
                      <div
                        onClick={() => {
                          if (!loadings.createLesson) {
                            let array = [
                              ...createLessonController.values.attachment,
                            ];
                            array = array.filter((o, ind) => ind != index);
                            createLessonController.setFieldValue(
                              "attachment",
                              array,
                            );
                          }
                        }}
                      >
                        <FiTrash />
                      </div>
                    </div>
                  ),
                )}
              </div>
              <input
                type="file"
                multiple
                onChange={handleUploadNewLessonFiles}
                hidden
                ref={uploadLessonFilesRefCreate}
              />
            </div>
            <div className="add_session_modal_content_right">
              <div
                style={
                  createLessonController.touched.video &&
                  createLessonController.errors.video
                    ? { borderColor: "red" }
                    : {}
                }
                className="upload_file"
              >
                {!createLessonController.values.video &&
                !createLessonController.values.videoId ? (
                  <p className="ant-upload-drag-icon">
                    <CloadAdd />
                  </p>
                ) : null}
                <p className="ant-upload-text">
                  {createLessonController.values.video
                    ? createLessonController.values.video?.file?.originalName
                      ? createLessonController.values.video?.file?.originalName
                      : createLessonController.values.video?.file?.name
                    : createLessonController.values.videoId?.title
                      ? createLessonController.values.videoId?.title
                      : "Choose a file from library"}
                </p>
                <p className="ant-upload-hint">
                  {createLessonController.values.video
                    ? formatSize(
                        createLessonController.values.video?.file?.size,
                      )
                    : createLessonController.values.videoId?.length
                      ? formatUnit(
                          createLessonController.values.videoId?.length,
                        )
                      : "Accepted format: MP4"}
                </p>
                <Dropdown
                  menu={{
                    items: [
                      {
                        label: (
                          <div
                            onClick={() => {
                              uploadLessonVideoRefCreate.current.click();
                            }}
                          >
                            Select new file
                          </div>
                        ),
                        key: "0",
                      },
                      {
                        label: (
                          <div
                            onClick={() => {
                              setLibraryModal(true);
                            }}
                          >
                            Select from library
                          </div>
                        ),
                        key: "1",
                      },
                    ],
                  }}
                  trigger={["click"]}
                >
                  <Button
                    disabled={loadings.createLesson}
                    className="browse_file_btn"
                  >
                    Upload video
                  </Button>
                </Dropdown>
                {createLessonController.values.video ? (
                  <Button
                    onClick={() => {
                      createLessonController.setFieldValue("video", null);
                      createLessonController.setFieldValue("videoId", null);
                    }}
                    disabled={loadings.createLesson}
                    className="remove_file_btn"
                  >
                    Remove file
                  </Button>
                ) : null}
                {createLessonController.values.video ? (
                  <video src={createLessonController.values.video?.url} />
                ) : null}
                {createLessonController.values.videoId ? (
                  <video src={createLessonController.values.videoId?.url} />
                ) : null}
              </div>
              <input
                type="file"
                onChange={handleUploadNewLesson}
                hidden
                accept=".mp4"
                ref={uploadLessonVideoRefCreate}
              />
            </div>
          </div>
          <div className="create_lesson_context_field">
            <label htmlFor="context">Context</label>
            <Editor
              apiKey="6nct7sklr88a59qr1lmnjytyu0wpj81vaq2f4qyemnyc2dzf"
              value={createLessonController.values.context}
              onInit={(evt, editor) => {
                createContextEditorRef.current = editor;
              }}
              onEditorChange={(content) => {
                createLessonController.setFieldValue("context", content);
              }}
              disabled={loadings.createLesson}
              init={getContextEditorInit(createContextEditorRef)}
            />
          </div>
          {loadings.createLesson && (
            <div style={{ marginTop: 24 }} className="upload_progressbar">
              <progress value={uploadLessonProgress} max="100"></progress>
              <span> {uploadLessonProgress}%</span>
            </div>
          )}
          <div className="save_cancel_btn_modal">
            <Button
              onClick={() => {
                setCreateLessonModal(false);
              }}
              disabled={loadings.createLesson}
            >
              Cancel
            </Button>
            <Button htmlType="submit" loading={loadings.createLesson}>
              Post
            </Button>
          </div>
        </form>
      </Modal>
      {/* update lesson modal */}
      <Modal
        open={updateLessonModal}
        onCancel={() => {
          setUpdateLessonModal(false);
        }}
        footer={null}
        className="addSessionModal"
        closeIcon={null}
      >
        <form
          onSubmit={updateLessonController.handleSubmit}
          className="add_session_modal"
        >
          <div className="add_session_modal_title">
            <Button
              onClick={() => {
                setUpdateLessonModal(false);
              }}
            >
              <IoClose />
            </Button>
            <h3>Edit Lesson</h3>
          </div>
          <div className="add_session_modal_content">
            <div className="add_session_modal_content_left">
              {/* title */}
              <div>
                <div>Title</div>
                <Input
                  value={updateLessonController.values.title}
                  onChange={updateLessonController.handleChange}
                  name="title"
                  id="title"
                  disabled={loadings.updateLesson}
                  status={
                    updateLessonController.touched.title &&
                    updateLessonController.errors.title
                      ? "error"
                      : ""
                  }
                />
              </div>
              {/* description */}
              <div>
                <div>Description</div>
                <Input
                  value={updateLessonController.values.description}
                  onChange={updateLessonController.handleChange}
                  name="description"
                  id="description"
                  disabled={loadings.updateLesson}
                />
              </div>
              {/* free */}
              <div>
                <div>Free Lesson</div>
                <Switch
                  checked={updateLessonController.values.free}
                  onChange={(value) => {
                    updateLessonController.setFieldValue("free", value);
                  }}
                  disabled={loadings.updateLesson}
                />
              </div>
              {/* files */}
              <div>
                <div>
                  <div>Add files</div>
                  <Button
                    onClick={() => {
                      uploadLessonFilesRefUpdate.current.click();
                    }}
                    disabled={loadings.updateLesson}
                    icon={<LuUpload />}
                  >
                    Click to Upload
                  </Button>
                </div>
                {updateLessonController.values.attachment?.map(
                  (file, index) => (
                    <div className="create_lesson_file_card" key={index}>
                      <div>
                        <div>{file?.name}</div>
                        <div>{formatSize(file?.size)}</div>
                      </div>
                      <div
                        onClick={() => {
                          if (!loadings.updateLesson) {
                            let array = [
                              ...updateLessonController.values.attachment,
                            ];
                            array = array.filter((o, ind) => ind != index);
                            updateLessonController.setFieldValue(
                              "attachment",
                              array,
                            );
                          }
                        }}
                      >
                        <FiTrash />
                      </div>
                    </div>
                  ),
                )}
              </div>
              <input
                type="file"
                multiple
                onChange={handleUploadNewLessonFilesUpdate}
                hidden
                ref={uploadLessonFilesRefUpdate}
              />
            </div>
            <div className="add_session_modal_content_right">
              <div
                style={
                  updateLessonController.touched.video &&
                  updateLessonController.errors.video
                    ? { borderColor: "red" }
                    : {}
                }
                className="upload_file"
              >
                {!updateLessonController.values.video &&
                !updateLessonController.values.videoId ? (
                  <p className="ant-upload-drag-icon">
                    <CloadAdd />
                  </p>
                ) : null}
                <p className="ant-upload-text">
                  {updateLessonController.values.video
                    ? updateLessonController.values.video?.file?.originalName
                      ? updateLessonController?.values.video?.file?.originalName
                      : updateLessonController.values.video?.file?.name
                    : updateLessonController.values.videoId
                      ? updateLessonController.values.videoId?.title
                      : "Choose a file from library"}
                </p>
                <p className="ant-upload-hint">
                  {updateLessonController.values.video
                    ? formatSize(
                        updateLessonController.values.video?.file?.size,
                      )
                    : updateLessonController.values.videoId
                      ? formatUnit(
                          updateLessonController.values.videoId?.length,
                        )
                      : "Accepted format: MP4"}
                </p>
                <Dropdown
                  menu={{
                    items: [
                      {
                        label: (
                          <div
                            onClick={() => {
                              uploadLessonVideoRefUpdate.current.click();
                            }}
                          >
                            Select new file
                          </div>
                        ),
                        key: "0",
                      },
                      {
                        label: (
                          <div
                            onClick={() => {
                              setLibraryModalUpdate(true);
                            }}
                          >
                            Select from library
                          </div>
                        ),
                        key: "1",
                      },
                    ],
                  }}
                  trigger={["click"]}
                >
                  <Button
                    disabled={loadings.createLesson}
                    className="browse_file_btn"
                  >
                    Upload video
                  </Button>
                </Dropdown>
                {updateLessonController.values.video ? (
                  <video src={updateLessonController.values.video?.url} />
                ) : null}
                {updateLessonController.values.videoId ? (
                  <video src={updateLessonController.values.videoId?.url} />
                ) : null}
              </div>
              <input
                type="file"
                onChange={handleUploadNewLessonUpdate}
                hidden
                accept=".mp4"
                ref={uploadLessonVideoRefUpdate}
              />
            </div>
          </div>
          <div className="create_lesson_context_field">
            <label htmlFor="context">Context</label>
            <Editor
              apiKey="6nct7sklr88a59qr1lmnjytyu0wpj81vaq2f4qyemnyc2dzf"
              value={updateLessonController.values.context}
              onInit={(evt, editor) => {
                updateContextEditorRef.current = editor;
              }}
              onEditorChange={(content) => {
                updateLessonController.setFieldValue("context", content);
              }}
              disabled={loadings.updateLesson}
              init={getContextEditorInit(updateContextEditorRef)}
            />
          </div>
          {loadings.updateLesson && (
            <div style={{ marginTop: 24 }} className="upload_progressbar">
              <progress value={uploadLessonProgress} max="100"></progress>
              <span> {uploadLessonProgress}%</span>
            </div>
          )}
          <div className="save_cancel_btn_modal">
            <Button
              onClick={() => {
                setUpdateLessonModal(false);
              }}
              disabled={loadings.updateLesson}
            >
              Cancel
            </Button>
            <Button htmlType="submit" loading={loadings.updateLesson}>
              Save Changes
            </Button>
          </div>
        </form>
      </Modal>
      {/* delete lesson modal */}
      <Modal
        open={deleteLessonModal}
        onCancel={() => {
          setDeleteLessonModal(false);
        }}
        footer={null}
        className="deleteCourseModal"
        closeIcon={null}
      >
        <div className="delete_course_modal_container">
          <div className="delete_course_modal_title">
            <Button
              onClick={() => {
                setDeleteLessonModal(false);
              }}
            >
              <IoClose />
            </Button>
            <IoCloseCircleOutline />
          </div>
          <div>
            <h3>Are you sure you want to permanently delete this lesson?</h3>
            <p>
              All products and quizzes associated with this lesson will also be
              deleted.
            </p>
          </div>
          <div className="delete_course_modal_btn">
            <Button
              onClick={() => {
                setDeleteLessonModal(false);
              }}
              disabled={loadings.deleteLesson}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                deleteLesson(selectedLesson?.id);
              }}
              loading={loadings.deleteLesson}
            >
              Yes, Delete
            </Button>
          </div>
        </div>
      </Modal>
      {/* create quiz modal */}
      <Modal
        open={createQuizModal}
        onCancel={() => {
          setCreateQuizModal(false);
        }}
        footer={null}
        className="addQuizzModal"
        closeIcon={null}
      >
        <form
          onSubmit={createQuizController.handleSubmit}
          className="add_quizz_modal_container"
        >
          <div className="add_quizz_modal_title">
            <Button
              onClick={() => {
                setCreateQuizModal(false);
              }}
            >
              <IoClose />
            </Button>
            <h3>New Quiz</h3>
          </div>
          {/* quiz_title */}
          <div className="create_quiz_title">
            <label htmlFor="quiz_title">Quiz title</label>
            <Input
              autoFocus
              name="quiz_title"
              id="quiz_title"
              disabled={loadings.createQuiz}
              value={createQuizController.values.quiz_title}
              onChange={createQuizController.handleChange}
              status={
                createQuizController.touched.quiz_title &&
                createQuizController.errors.quiz_title
                  ? "error"
                  : ""
              }
            />
          </div>
          {/* questions */}
          {createQuizController.values.questions?.map((question, index) => (
            <div key={index} className="form_quizz">
              <div className="question_container">
                <div className="question_item">
                  {/* question label */}
                  <div>
                    <label>Question {index + 1}</label>
                    {index > 0 ? (
                      <HiOutlineTrash
                        onClick={() => {
                          if (!loadings.createQuiz) {
                            let array = [
                              ...createQuizController.values.questions,
                            ];
                            array = array.filter((o, ind) => ind != index);
                            createQuizController.setFieldValue(
                              "questions",
                              array,
                            );
                          }
                        }}
                      />
                    ) : null}
                  </div>
                  {/* question title */}
                  <Input
                    value={question.title}
                    onChange={(e) => {
                      let array = [...createQuizController.values.questions];
                      array[index].title = e.target.value;
                      createQuizController.setFieldValue("questions", array);
                    }}
                    disabled={loadings.createQuiz}
                    name="title"
                    id="title"
                    placeholder="Write your question"
                    status={
                      createQuizController.touched?.questions?.[index]?.title &&
                      createQuizController.errors?.questions?.[index]?.title
                        ? "error"
                        : ""
                    }
                  />
                  <div>Answers (Choose single or multiple correct answers)</div>
                  {/* answers */}
                  {question.answers.map((answer, answerIndex) => (
                    <div className="answer_item" key={answerIndex}>
                      <div>
                        <Input
                          onChange={(e) => {
                            let array = [
                              ...createQuizController.values.questions,
                            ];
                            array[index].answers[answerIndex].title =
                              e.target.value;
                            createQuizController.setFieldValue(
                              "questions",
                              array,
                            );
                          }}
                          disabled={loadings.createQuiz}
                          status={
                            createQuizController.touched?.questions?.[index]
                              ?.answers?.[answerIndex]?.title &&
                            createQuizController.errors?.questions?.[index]
                              ?.answers?.[answerIndex]?.title
                              ? "error"
                              : ""
                          }
                          placeholder="Write your answer"
                        />
                      </div>
                      <div
                        className={`${
                          createQuizController.touched?.questions?.[index]
                            ?.answers &&
                          typeof createQuizController.errors?.questions?.[index]
                            ?.answers === "string"
                            ? "quiz_checkbox_error"
                            : ""
                        }`}
                      >
                        <Checkbox
                          checked={answer.isAnswer}
                          disabled={loadings.createQuiz}
                          onChange={(e) => {
                            let array = [
                              ...createQuizController.values.questions,
                            ];
                            array[index].answers[answerIndex].isAnswer =
                              e.target.checked;
                            createQuizController.setFieldValue(
                              "questions",
                              array,
                            );
                          }}
                        />
                        {answerIndex > 0 ? (
                          <Button
                            onClick={() => {
                              if (!loadings.createQuiz) {
                                let array = [
                                  ...createQuizController.values.questions,
                                ];
                                array[index].answers = array[
                                  index
                                ].answers.filter(
                                  (_, ind) => ind !== answerIndex,
                                );
                                createQuizController.setFieldValue(
                                  "questions",
                                  array,
                                );
                              }
                            }}
                          >
                            <HiOutlineTrash />
                          </Button>
                        ) : (
                          <Button disabled></Button>
                        )}
                      </div>
                    </div>
                  ))}
                  {/* add answer button */}
                  <Button
                    disabled={loadings.createQuiz}
                    onClick={() => {
                      if (!loadings.createQuiz) {
                        let array = [...createQuizController.values.questions];
                        array[index].answers.push({
                          title: "",
                          isAnswer: false,
                        });
                        createQuizController.setFieldValue("questions", array);
                      }
                    }}
                  >
                    <MdAdd />
                    <span>Add answer</span>
                  </Button>
                </div>
              </div>
            </div>
          ))}
          {/* add question button */}
          <div className="form_quizz_add_btn">
            <Button
              disabled={loadings.createQuiz}
              onClick={() => {
                if (!loadings.createQuiz) {
                  let array = [...createQuizController.values.questions];
                  array.push({
                    title: "",
                    answers: [
                      {
                        title: "",
                        isAnswer: false,
                      },
                    ],
                  });
                  createQuizController.setFieldValue("questions", array);
                }
              }}
            >
              <MdAdd />
              <span> Add question</span>
            </Button>
          </div>
          {/* form submit button */}
          <div className="cancel_save_btn">
            <Button
              onClick={() => {
                setCreateQuizModal(false);
              }}
              disabled={loadings.createQuiz}
            >
              Cancel
            </Button>
            <Button htmlType="submit" loading={loadings.createQuiz}>
              Post
            </Button>
          </div>
        </form>
      </Modal>
      {/* update quiz modal */}
      <Modal
        open={updateQuizModal}
        onCancel={() => {
          setUpdateQuizModal(false);
        }}
        footer={null}
        className="addQuizzModal"
        closeIcon={null}
      >
        <form
          onSubmit={updateQuizController.handleSubmit}
          className="add_quizz_modal_container"
        >
          <div className="add_quizz_modal_title">
            <Button
              onClick={() => {
                setUpdateQuizModal(false);
              }}
            >
              <IoClose />
            </Button>
            <h3>Edit Quiz</h3>
          </div>
          {/* quiz_title */}
          <div className="create_quiz_title">
            <label htmlFor="quiz_title">Quiz title</label>
            <Input
              autoFocus
              name="quiz_title"
              id="quiz_title"
              disabled={loadings.updateQuiz}
              value={updateQuizController.values.quiz_title}
              onChange={updateQuizController.handleChange}
              status={
                updateQuizController.touched.quiz_title &&
                updateQuizController.errors.quiz_title
                  ? "error"
                  : ""
              }
            />
          </div>
          {/* questions */}
          {updateQuizController.values.questions?.map((question, index) => (
            <div key={index} className="form_quizz">
              <div className="question_container">
                <div className="question_item">
                  {/* question label */}
                  <div>
                    <label>Question {index + 1}</label>
                    {index > 0 ? (
                      <HiOutlineTrash
                        onClick={() => {
                          if (!loadings.updateQuiz) {
                            let array = [
                              ...updateQuizController.values.questions,
                            ];
                            array = array.filter((o, ind) => ind != index);
                            updateQuizController.setFieldValue(
                              "questions",
                              array,
                            );
                          }
                        }}
                      />
                    ) : null}
                  </div>
                  {/* question title */}
                  <Input
                    value={question.title}
                    onChange={(e) => {
                      let array = [...updateQuizController.values.questions];
                      array[index].title = e.target.value;
                      updateQuizController.setFieldValue("questions", array);
                    }}
                    disabled={loadings.updateQuiz}
                    name="title"
                    id="title"
                    placeholder="Write your question"
                    status={
                      updateQuizController.touched?.questions?.[index]?.title &&
                      updateQuizController.errors?.questions?.[index]?.title
                        ? "error"
                        : ""
                    }
                  />
                  <div>Answers (Choose single or multiple correct answers)</div>
                  {/* answers */}
                  {question.answers.map((answer, answerIndex) => (
                    <div className="answer_item" key={answerIndex}>
                      <div>
                        <Input
                          onChange={(e) => {
                            let array = [
                              ...updateQuizController.values.questions,
                            ];
                            array[index].answers[answerIndex].title =
                              e.target.value;
                            updateQuizController.setFieldValue(
                              "questions",
                              array,
                            );
                          }}
                          value={answer.title}
                          disabled={loadings.updateQuiz}
                          status={
                            updateQuizController.touched?.questions?.[index]
                              ?.answers?.[answerIndex]?.title &&
                            updateQuizController.errors?.questions?.[index]
                              ?.answers?.[answerIndex]?.title
                              ? "error"
                              : ""
                          }
                          placeholder="Write your answer"
                        />
                      </div>
                      <div
                        className={`${
                          updateQuizController.touched?.questions?.[index]
                            ?.answers &&
                          typeof updateQuizController.errors?.questions?.[index]
                            ?.answers === "string"
                            ? "quiz_checkbox_error"
                            : ""
                        }`}
                      >
                        <Checkbox
                          checked={answer.isAnswer}
                          disabled={loadings.updateQuiz}
                          onChange={(e) => {
                            let array = [
                              ...updateQuizController.values.questions,
                            ];
                            array[index].answers[answerIndex].isAnswer =
                              e.target.checked;
                            updateQuizController.setFieldValue(
                              "questions",
                              array,
                            );
                          }}
                        />
                        {answerIndex > 0 ? (
                          <Button
                            onClick={() => {
                              if (!loadings.updateQuiz) {
                                let array = [
                                  ...updateQuizController.values.questions,
                                ];
                                array[index].answers = array[
                                  index
                                ].answers.filter(
                                  (_, ind) => ind !== answerIndex,
                                );
                                updateQuizController.setFieldValue(
                                  "questions",
                                  array,
                                );
                              }
                            }}
                          >
                            <HiOutlineTrash />
                          </Button>
                        ) : (
                          <Button disabled></Button>
                        )}
                      </div>
                    </div>
                  ))}
                  {/* add answer button */}
                  <Button
                    disabled={loadings.updateQuiz}
                    onClick={() => {
                      if (!loadings.updateQuiz) {
                        let array = [...updateQuizController.values.questions];
                        array[index].answers.push({
                          title: "",
                          isAnswer: false,
                        });
                        updateQuizController.setFieldValue("questions", array);
                      }
                    }}
                  >
                    <MdAdd />
                    <span>Add answer</span>
                  </Button>
                </div>
              </div>
            </div>
          ))}
          {/* add question button */}
          <div className="form_quizz_add_btn">
            <Button
              disabled={loadings.updateQuiz}
              onClick={() => {
                if (!loadings.updateQuiz) {
                  let array = [...updateQuizController.values.questions];
                  array.push({
                    title: "",
                    answers: [
                      {
                        title: "",
                        isAnswer: false,
                      },
                    ],
                  });
                  updateQuizController.setFieldValue("questions", array);
                }
              }}
            >
              <MdAdd />
              <span> Add question</span>
            </Button>
          </div>
          {/* form submit button */}
          <div className="cancel_save_btn">
            <Button
              onClick={() => {
                setUpdateQuizModal(false);
              }}
              disabled={loadings.updateQuiz}
            >
              Cancel
            </Button>
            <Button htmlType="submit" loading={loadings.updateQuiz}>
              Save Changes
            </Button>
          </div>
        </form>
      </Modal>
      {/* delete quiz modal */}
      <Modal
        open={deleteQuizModal}
        onCancel={() => {
          setDeleteQuizModal(false);
        }}
        footer={null}
        className="deleteCourseModal"
        closeIcon={null}
      >
        <div className="delete_course_modal_container">
          <div className="delete_course_modal_title">
            <Button
              onClick={() => {
                setDeleteQuizModal(false);
              }}
            >
              <IoClose />
            </Button>
            <IoCloseCircleOutline />
          </div>
          <div>
            <h3>Are you sure you want to permanently delete this quiz?</h3>
            <p>
              All questions and answers associated with this quiz will also be
              deleted.
            </p>
          </div>
          <div className="delete_course_modal_btn">
            <Button
              onClick={() => {
                setDeleteQuizModal(false);
              }}
              disabled={loadings.deleteQuiz}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                deleteQuiz(selectedQuiz?.id);
              }}
              loading={loadings.deleteQuiz}
            >
              Yes, Delete
            </Button>
          </div>
        </div>
      </Modal>
      {/* create product modal */}
      <Modal
        open={createProductModal}
        onCancel={() => {
          setCreateProductModal(false);
        }}
        footer={null}
        className="addProductModal"
        closeIcon={null}
      >
        <form
          onSubmit={createProductController.handleSubmit}
          className="add_product_modal_container"
        >
          <div className="add_product_modal_title">
            <Button
              onClick={() => {
                setCreateProductModal(false);
              }}
            >
              <IoClose />
            </Button>
            <h3>Add Product</h3>
          </div>
          <div className="add_product_modal_content">
            <div className="add_product_modal_content_left">
              {/* title */}
              <div>
                <div>Title</div>
                <Input
                  name="title"
                  id="title"
                  disabled={loadings.createProduct}
                  value={createProductController.values.title}
                  onChange={createProductController.handleChange}
                  status={
                    createProductController.touched.title &&
                    createProductController.errors.title
                      ? "error"
                      : ""
                  }
                  placeholder="example"
                />
              </div>
              {/* description */}
              <div>
                <div>Description</div>
                <Input
                  name="description"
                  id="description"
                  disabled={loadings.createProduct}
                  value={createProductController.values.description}
                  onChange={createProductController.handleChange}
                  status={
                    createProductController.touched.description &&
                    createProductController.errors.description
                      ? "error"
                      : ""
                  }
                  placeholder="example"
                />
              </div>
              {/* link */}
              <div>
                <div>Link</div>
                <Input
                  name="link"
                  id="link"
                  disabled={loadings.createProduct}
                  value={createProductController.values.link}
                  onChange={createProductController.handleChange}
                  status={
                    createProductController.touched.link &&
                    createProductController.errors.link
                      ? "error"
                      : ""
                  }
                />
              </div>
              {/* lessonIds */}
              <div>
                <div>Lessons</div>
                <Select
                  options={(viewCourseData?.course?.sections ?? []).map(
                    (sec) => ({
                      label: sec?.title ?? `Section ${sec?.id}`,
                      options: (sec?.lessons ?? []).map((les) => ({
                        label: les?.title ?? `Lesson ${les?.id}`,
                        value: les.id,
                      })),
                    }),
                  )}
                  disabled={loadings.createProduct}
                  mode="multiple"
                  value={createProductController.values.lessonIds}
                  onChange={(value) => {
                    createProductController.setFieldValue("lessonIds", value);
                  }}
                  status={
                    createProductController.touched.lessonIds &&
                    createProductController.errors.lessonIds
                      ? "error"
                      : ""
                  }
                />
              </div>
            </div>
            <div className="add_product_modal_content_right">
              <div className="upload_file">
                {!createProductController.values.product ? (
                  <p className="ant-upload-drag-icon">
                    <CloadAdd />
                  </p>
                ) : null}
                <p className="ant-upload-text">
                  {createProductController.values.product
                    ? createProductController.values.product?.file?.originalName
                      ? createProductController.values.product?.file
                          ?.originalName
                      : createProductController.values.product?.file?.name
                    : "Choose a file from library"}
                </p>
                <p className="ant-upload-hint">
                  {createProductController.values.product
                    ? formatSize(
                        createProductController.values.product?.file?.size,
                      )
                    : "Accepted formats: PNG, JPG, JPEG, WEBP"}
                </p>
                <Button
                  onClick={() => {
                    uploadProductImageRefCreate.current.click();
                  }}
                  disabled={loadings.createProduct}
                  className="browse_file_btn"
                >
                  Browse file
                </Button>
                {createProductController.values.product ? (
                  <Button
                    onClick={() => {
                      createProductController.setFieldValue("product", null);
                    }}
                    disabled={loadings.createProduct}
                    className="remove_file_btn"
                  >
                    Remove file
                  </Button>
                ) : null}
                {createProductController.values.product ? (
                  <img
                    src={createProductController.values.product?.url}
                    alt={"Product image"}
                  />
                ) : null}
              </div>
              <input
                type="file"
                onChange={handleUploadNewProduct}
                hidden
                accept="image/*"
                ref={uploadProductImageRefCreate}
              />
            </div>
          </div>
          <div className="save_cancel_btn_modal">
            <Button
              disabled={loadings.createProduct}
              onClick={() => {
                setCreateProductModal(false);
              }}
            >
              Cancel
            </Button>
            <Button htmlType="submit" loading={loadings.createProduct}>
              Post
            </Button>
          </div>
        </form>
      </Modal>
      {/* update product modal */}
      <Modal
        open={updateProductModal}
        onCancel={() => {
          setUpdateProductModal(false);
        }}
        footer={null}
        className="addProductModal"
        closeIcon={null}
      >
        <form
          onSubmit={updateProductController.handleSubmit}
          className="add_product_modal_container"
        >
          <div className="add_product_modal_title">
            <Button
              onClick={() => {
                setUpdateProductModal(false);
              }}
            >
              <IoClose />
            </Button>
            <h3>Edit Product</h3>
          </div>
          <div className="add_product_modal_content">
            <div className="add_product_modal_content_left">
              {/* title */}
              <div>
                <div>Title</div>
                <Input
                  name="title"
                  id="title"
                  disabled={loadings.updateProduct}
                  value={updateProductController.values.title}
                  onChange={updateProductController.handleChange}
                  status={
                    updateProductController.touched.title &&
                    updateProductController.errors.title
                      ? "error"
                      : ""
                  }
                  placeholder="example"
                />
              </div>
              {/* description */}
              <div>
                <div>Description</div>
                <Input
                  name="description"
                  id="description"
                  disabled={loadings.updateProduct}
                  value={updateProductController.values.description}
                  onChange={updateProductController.handleChange}
                  status={
                    updateProductController.touched.description &&
                    updateProductController.errors.description
                      ? "error"
                      : ""
                  }
                  placeholder="example"
                />
              </div>
              {/* link */}
              <div>
                <div>Link</div>
                <Input
                  name="link"
                  id="link"
                  disabled={loadings.updateProduct}
                  value={updateProductController.values.link}
                  onChange={updateProductController.handleChange}
                  status={
                    updateProductController.touched.link &&
                    updateProductController.errors.link
                      ? "error"
                      : ""
                  }
                />
              </div>
              {/* lessonIds */}
              <div>
                <div>Lessons</div>
                <Select
                  options={(viewCourseData?.course?.sections ?? []).map(
                    (sec) => ({
                      label: sec?.title ?? `Section ${sec?.id}`,
                      options: (sec?.lessons ?? []).map((les) => ({
                        label: les?.title ?? `Lesson ${les?.id}`,
                        value: les.id,
                      })),
                    }),
                  )}
                  mode="multiple"
                  value={updateProductController.values.lessonIds}
                  onChange={(value) => {
                    updateProductController.setFieldValue("lessonIds", value);
                  }}
                  disabled={loadings.updateProduct}
                  status={
                    updateProductController.touched.lessonIds &&
                    updateProductController.errors.lessonIds
                      ? "error"
                      : ""
                  }
                />
              </div>
            </div>
            <div className="add_product_modal_content_right">
              <div className="upload_file">
                {!updateProductController.values.product ? (
                  <p className="ant-upload-drag-icon">
                    <CloadAdd />
                  </p>
                ) : null}
                <p className="ant-upload-text">
                  {updateProductController.values.product
                    ? updateProductController.values.product?.file?.originalName
                      ? updateProductController.values.product?.file
                          ?.originalName
                      : updateProductController.values.product?.file?.name
                    : "Choose a file from library"}
                </p>
                <p className="ant-upload-hint">
                  {updateProductController.values.product
                    ? formatSize(
                        updateProductController.values.product?.file?.size,
                      )
                    : "Accepted formats: PNG, JPG, JPEG, WEBP"}
                </p>
                <Button
                  onClick={() => {
                    uploadProductImageRefUpdate.current.click();
                  }}
                  disabled={loadings.updateProduct}
                  className="browse_file_btn"
                >
                  Browse file
                </Button>
                {updateProductController.values.product ? (
                  <Button
                    onClick={() => {
                      updateProductController.setFieldValue("product", null);
                    }}
                    disabled={loadings.updateProduct}
                    className="remove_file_btn"
                  >
                    Remove file
                  </Button>
                ) : null}
                {updateProductController.values.product ? (
                  <img
                    src={updateProductController.values.product?.url}
                    alt={updateProductController.values.product.name}
                  />
                ) : null}
              </div>
              <input
                type="file"
                onChange={handleUploadUpdateProduct}
                hidden
                accept="image/*"
                ref={uploadProductImageRefUpdate}
              />
            </div>
          </div>
          <div className="save_cancel_btn_modal">
            <Button
              disabled={loadings.updateProduct}
              onClick={() => {
                setUpdateProductModal(false);
              }}
            >
              Cancel
            </Button>
            <Button htmlType="submit" loading={loadings.updateProduct}>
              Save Changes
            </Button>
          </div>
        </form>
      </Modal>
      {/* delete product modal */}
      <Modal
        open={deleteProductModal}
        onCancel={() => setDeleteProductModal(false)}
        footer={null}
        className="deleteCourseModal"
        closeIcon={null}
      >
        <div className="delete_course_modal_container">
          <div className="delete_course_modal_title">
            <Button
              onClick={() => {
                setDeleteProductModal(false);
              }}
            >
              <IoClose />
            </Button>
            <IoCloseCircleOutline />
          </div>
          <div>
            <h3>Are you sure you want to delete this product?</h3>
            <p>
              This action will remove the product from the lesson, and students
              will no longer see or access its link.
            </p>
          </div>
          <div className="delete_course_modal_btn">
            <Button
              onClick={() => {
                setDeleteProductModal(false);
              }}
              disabled={loadings.deleteProduct}
            >
              Cancel
            </Button>
            <Button
              loading={loadings.deleteProduct}
              onClick={() => {
                deleteProduct(selectedProduct?.id);
              }}
            >
              Yes, Delete
            </Button>
          </div>
        </div>
      </Modal>
      {/* reply review modal */}
      <Modal
        open={replyModal}
        onCancel={() => {
          setReplyModal(false);
        }}
        footer={null}
        className="editLessonModal"
        closeIcon={null}
      >
        <form
          onSubmit={replyReviewController.handleSubmit}
          className="edit_lesson_modal_container"
        >
          <div className="edit_lesson_modal_title">
            <Button
              onClick={() => {
                setReplyModal(false);
              }}
            >
              <IoClose />
            </Button>
            <h3>Reply Review</h3>
          </div>
          <div style={{ marginBottom: 0 }}></div>
          {/* comment */}
          <div>
            <label>Comment</label>
            <TextArea
              name="comment"
              id="comment"
              value={replyReviewController.values.comment}
              onChange={replyReviewController.handleChange}
              disabled={loadings.replyReview}
              rows={4}
              status={
                replyReviewController.touched.comment &&
                replyReviewController.errors.comment
                  ? "error"
                  : ""
              }
            />
          </div>
          <div className="edit_lesson_modal_btn">
            <Button htmlType="submit" loading={loadings.replyReview}>
              Post
            </Button>
            <Button
              disabled={loadings.replyReview}
              onClick={() => {
                setReplyModal(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </form>
      </Modal>
      {/* report review modal */}
      <Modal
        open={reportModal}
        onCancel={() => {
          setReportModal(false);
        }}
        footer={null}
        className="editLessonModal"
        closeIcon={null}
      >
        <form
          onSubmit={reportReviewController.handleSubmit}
          className="edit_lesson_modal_container"
        >
          <div className="edit_lesson_modal_title">
            <Button
              onClick={() => {
                setReportModal(false);
              }}
            >
              <IoClose />
            </Button>
            <h3>Report Review</h3>
          </div>
          <div style={{ marginBottom: 0 }}></div>
          {/* reason */}
          <div>
            <label>Reason</label>
            <TextArea
              name="reason"
              id="reason"
              value={reportReviewController.values.reason}
              onChange={reportReviewController.handleChange}
              disabled={loadings.reportReview}
              rows={4}
              status={
                reportReviewController.touched.reason &&
                reportReviewController.errors.reason
                  ? "error"
                  : ""
              }
            />
          </div>
          <div className="edit_lesson_modal_btn">
            <Button htmlType="submit" loading={loadings.reportReview}>
              Send
            </Button>
            <Button
              disabled={loadings.reportReview}
              onClick={() => {
                setReportModal(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </form>
      </Modal>
      {/* generate certificate modal */}
      <Modal
        open={certificateModal}
        onCancel={() => {
          setCertificateModal(false);
        }}
        footer={null}
        className="addSessionModal"
        closeIcon={null}
      >
        <form
          onSubmit={generateCertificateController.handleSubmit}
          className="add_session_modal"
        >
          <div className="add_session_modal_title">
            <Button
              onClick={() => {
                setCertificateModal(false);
              }}
            >
              <IoClose />
            </Button>
            <h3>Generate Certificate</h3>
          </div>
          <div className="add_session_modal_content generate_certificate_form">
            <div
              style={{ width: "100%" }}
              className="add_session_modal_content_right"
            >
              <div
                style={
                  generateCertificateController.touched.certificate &&
                  generateCertificateController.errors.certificate
                    ? { borderColor: "red" }
                    : {}
                }
                className="upload_file"
              >
                {!generateCertificateController.values.certificate ? (
                  <p className="ant-upload-drag-icon">
                    <CloadAdd />
                  </p>
                ) : null}
                <p className="ant-upload-text">
                  {generateCertificateController.values.certificate
                    ? generateCertificateController.values.certificate?.file
                        ?.name
                    : "Choose a file from library"}
                </p>
                <p className="ant-upload-hint">
                  {generateCertificateController.values.certificate
                    ? formatSize(
                        generateCertificateController.values.certificate?.file
                          ?.size,
                      )
                    : "Accepted formats: PNG, JPG, JPEG, WEBP"}
                </p>
                <Button
                  onClick={() => {
                    generateCertificateRef.current.click();
                  }}
                  disabled={loadings.generateCertificate}
                  className="browse_file_btn"
                >
                  Browse file
                </Button>
                {generateCertificateController.values.certificate ? (
                  <Button
                    onClick={() => {
                      generateCertificateController.setFieldValue(
                        "certificate",
                        null,
                      );
                    }}
                    disabled={loadings.generateCertificate}
                    className="remove_file_btn"
                  >
                    Remove file
                  </Button>
                ) : null}
                {generateCertificateController.values.certificate ? (
                  <img
                    src={generateCertificateController.values.certificate?.url}
                    alt={"Certificate image"}
                  />
                ) : null}
              </div>
              <input
                type="file"
                onChange={handleUploadCertificate}
                hidden
                accept="image/*"
                ref={generateCertificateRef}
              />
            </div>
          </div>
          <div className="save_cancel_btn_modal">
            <Button
              onClick={() => {
                setCertificateModal(false);
              }}
              disabled={loadings.generateCertificate}
            >
              Cancel
            </Button>
            <Button htmlType="submit" loading={loadings.generateCertificate}>
              Post
            </Button>
          </div>
        </form>
      </Modal>
      {/* new library modal */}
      <Modal
        open={libraryModal}
        onCancel={() => {
          setLibraryModal(false);
        }}
        footer={null}
        className="addQuizzModal"
        closeIcon={null}
      >
        <div
          id="add_quizz_modal_container_no_padding"
          className="add_quizz_modal_container"
        >
          <div className="add_quizz_modal_title">
            <Button
              onClick={() => {
                setLibraryModal(false);
              }}
            >
              <IoClose />
            </Button>
            <h3>Select file from library</h3>
          </div>
          <div className="collections_list">
            {getCollectionsLoading
              ? Array(2)
                  .fill()
                  ?.map((item, itemIndex) => (
                    <Skeleton
                      key={itemIndex}
                      style={{
                        width: "100%",
                        height: 48,
                        marginBottom: 8,
                        borderRadius: 8,
                      }}
                    />
                  ))
              : collectionsData
                  ?.filter((course) => course.status == 1 || course.status == 2)
                  ?.map((collection, index) => (
                    <Collapse
                      key={index}
                      className={"collection_panel"}
                      activeKey={collectionsActiveKeys}
                      onChange={(key) => {
                        if (!collection.loading) {
                          setCollectionsActiveKeys(key);
                          if (
                            key.find(
                              (o) =>
                                o == collection?.id &&
                                collection?.videos?.length == 0,
                            )
                          ) {
                            getCollectionVideos(
                              collection?.meta?.guid,
                              collection.id,
                            );
                          }
                        }
                      }}
                      expandIconPosition="end"
                    >
                      <Panel
                        header={
                          <div className="label_collapse">
                            <div>
                              <h4>{collection.name}</h4>
                            </div>
                            {collection?.loading ? (
                              <img
                                src={LoadingPrimary}
                                width={20}
                                height={20}
                                alt="Loading..."
                              />
                            ) : null}
                          </div>
                        }
                        key={collection?.id}
                        className="custom_panel"
                        showArrow={true}
                      >
                        <div className="collection_panel_body">
                          {collection?.loading
                            ? Array(3)
                                .fill()
                                .map((loadingItem, loadingItemIndex) => (
                                  <Skeleton
                                    style={{
                                      width: "calc(50% - 8px)",
                                      marginBottom: 8,
                                      height: 255,
                                      borderRadius: 8,
                                    }}
                                  />
                                ))
                            : collection?.videos?.map((video, videoIndex) => (
                                <div
                                  className={"library_video_item"}
                                  key={videoIndex}
                                >
                                  <div>
                                    {video?.thumbnail ? (
                                      <img
                                        src={video.thumbnail}
                                        alt={video.title}
                                      />
                                    ) : null}
                                    <div
                                      onClick={() => {
                                        window.open(video?.url, "_blank");
                                      }}
                                    >
                                      <FaCirclePlay />
                                    </div>
                                  </div>
                                  <div>
                                    <Tooltip
                                      title={video?.title}
                                      placement="topCenter"
                                    >
                                      <h4>
                                        {video?.title?.length > 15
                                          ? video?.title?.slice(0, 15) +
                                            "......" +
                                            video?.title?.slice(-10)
                                          : video?.title}
                                      </h4>
                                    </Tooltip>
                                    <div>
                                      <span>{formatUnit(video?.length)}</span>
                                    </div>
                                    <Button
                                      onClick={() => {
                                        createLessonController.setFieldValue(
                                          "videoId",
                                          video,
                                        );
                                        createLessonController.setFieldValue(
                                          "video",
                                          null,
                                        );
                                        setLibraryModal(false);
                                      }}
                                      id={
                                        createLessonController.values.videoId
                                          ?.guid == video?.guid
                                          ? "active_video_btn"
                                          : null
                                      }
                                    >
                                      {createLessonController.values.videoId
                                        ?.guid == video?.guid
                                        ? "Selected"
                                        : "Select"}
                                    </Button>
                                  </div>
                                </div>
                              ))}
                          {collection?.videos?.length == 0 &&
                          !collection?.loading ? (
                            <div
                              style={{
                                width: "100%",
                                textAlign: "center",
                                padding: "16px 0",
                                textAlign: "center",
                              }}
                            >
                              No videos in this collection
                            </div>
                          ) : null}
                        </div>
                      </Panel>
                    </Collapse>
                  ))}
          </div>
        </div>
      </Modal>
      {/* update library modal */}
      <Modal
        open={libraryModalUpdate}
        onCancel={() => {
          setLibraryModalUpdate(false);
        }}
        footer={null}
        className="addQuizzModal"
        closeIcon={null}
      >
        <div
          id="add_quizz_modal_container_no_padding"
          className="add_quizz_modal_container"
        >
          <div className="add_quizz_modal_title">
            <Button
              onClick={() => {
                setLibraryModalUpdate(false);
              }}
            >
              <IoClose />
            </Button>
            <h3>Select file from library</h3>
          </div>
          <div className="collections_list">
            {getCollectionsLoading
              ? Array(2)
                  .fill()
                  ?.map((item, itemIndex) => (
                    <Skeleton
                      key={itemIndex}
                      style={{
                        width: "100%",
                        height: 48,
                        marginBottom: 8,
                        borderRadius: 8,
                      }}
                    />
                  ))
              : collectionsData
                  ?.filter((course) => course.status == 1 || course.status == 2)
                  ?.map((collection, index) => (
                    <Collapse
                      key={index}
                      className={"collection_panel"}
                      activeKey={collectionsActiveKeys}
                      onChange={(key) => {
                        if (!collection.loading) {
                          setCollectionsActiveKeys(key);
                          if (
                            key.find(
                              (o) =>
                                o == collection?.id &&
                                collection?.videos?.length == 0,
                            )
                          ) {
                            getCollectionVideos(
                              collection?.meta?.guid,
                              collection.id,
                            );
                          }
                        }
                      }}
                      expandIconPosition="end"
                    >
                      <Panel
                        header={
                          <div className="label_collapse">
                            <div>
                              <h4>{collection.name}</h4>
                            </div>
                            {collection?.loading ? (
                              <img
                                src={LoadingPrimary}
                                width={20}
                                height={20}
                                alt="Loading..."
                              />
                            ) : null}
                          </div>
                        }
                        key={collection?.id}
                        className="custom_panel"
                        showArrow={true}
                      >
                        <div className="collection_panel_body">
                          {collection?.loading
                            ? Array(3)
                                .fill()
                                .map((loadingItem, loadingItemIndex) => (
                                  <Skeleton
                                    style={{
                                      width: "calc(50% - 8px)",
                                      marginBottom: 8,
                                      height: 255,
                                      borderRadius: 8,
                                    }}
                                  />
                                ))
                            : collection?.videos?.map((video, videoIndex) => (
                                <div
                                  className={"library_video_item"}
                                  key={videoIndex}
                                >
                                  <div>
                                    {video?.thumbnail ? (
                                      <img
                                        src={video.thumbnail}
                                        alt={video.title}
                                      />
                                    ) : null}
                                    <div
                                      onClick={() => {
                                        window.open(video?.url, "_blank");
                                      }}
                                    >
                                      <FaCirclePlay />
                                    </div>
                                  </div>
                                  <div>
                                    <Tooltip
                                      title={video?.file?.originalName}
                                      placement="topCenter"
                                    >
                                      <h4>
                                        {video?.title?.length > 15
                                          ? video?.title?.slice(0, 15) +
                                            "......" +
                                            video?.title?.slice(-10)
                                          : video?.title}
                                      </h4>
                                    </Tooltip>
                                    <div>
                                      <span>{formatUnit(video?.length)}</span>
                                    </div>
                                    <Button
                                      onClick={() => {
                                        updateLessonController.setFieldValue(
                                          "videoId",
                                          video,
                                        );
                                        updateLessonController.setFieldValue(
                                          "video",
                                          null,
                                        );
                                        setLibraryModalUpdate(false);
                                      }}
                                      id={
                                        updateLessonController.values.videoId
                                          ?.guid == video?.guid
                                          ? "active_video_btn"
                                          : null
                                      }
                                    >
                                      {updateLessonController.values.videoId
                                        ?.guid == video?.guid
                                        ? "Selected"
                                        : "Select"}
                                    </Button>
                                  </div>
                                </div>
                              ))}
                          {collection?.videos?.length == 0 &&
                          !collection?.loading ? (
                            <div
                              style={{
                                width: "100%",
                                textAlign: "center",
                                padding: "16px 0",
                                textAlign: "center",
                              }}
                            >
                              No videos in this collection
                            </div>
                          ) : null}
                        </div>
                      </Panel>
                    </Collapse>
                  ))}
          </div>
        </div>
      </Modal>
    </Layout>
  );
};

export default ViewCourse;
